import { eAtlas_0, eFontAsset, eGameAPI, Game } from "../../../Game";
import { SaveState } from "../../../SaveState";
import { eAdMode, eAdShowRes, eAdState, eSDKType, SDKBase } from "../../../SDK/SDKBase";
import { ScaleManager } from "../../../Utils/ScaleManager";
import { TextureAtlasUtils } from "../../../Utils/TextuAtlasUtils";
import { Gameplay } from "../../Gameplay";
import { Player } from "../Player/Player";



const enum eAdRequest {
    extraLife,
    newGame,
}



export class GameOver {
    private _layer: pc.Entity;
    private _overlay: pc.Entity;
    private _lblHighScore: pc.Entity;
    private _lblNewHighScore: pc.Entity;
    private _txtScore: pc.Entity;
    private _txtHighScore: pc.Entity;
    private _btnExtraLife: pc.Entity;
    private _btnNewGame: pc.Entity;

    private _hsColor = new pc.Color(255 / 255, 174 / 255, 0);
    private _nonHsColor = new pc.Color(1, 1, 1);

    /**
     * Prodleva do prehrani reklamy pro NEW GAME
     */
    private _newGameAdDelay: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(screen: pc.Entity) {
        // Layer
        this._layer = new pc.Entity("gameOver");
        this._layer.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_GROUP,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            width: 0,
            height: 0,
        });
        screen.addChild(this._layer);

        // Screen Overlay
        this._overlay = new pc.Entity();
        this._overlay.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0, 0],
            color: new pc.Color(0, 0, 0),
            opacity: 0.75,
        });
        this._layer.addChild(this._overlay);

        // Score
        let lblScore = this.createLabel(eAtlas_0.lblScore, new pc.Vec2(102, 32));
        this._txtScore = this.createText();

        // High Score
        this._lblHighScore = this.createLabel(eAtlas_0.lblHighScore, new pc.Vec2(156, 38));
        this._lblNewHighScore = this.createLabel(eAtlas_0.lblNewHighScore, new pc.Vec2(324, 46));
        this._txtHighScore = this.createText();
        this._txtHighScore.element.color = this._hsColor;

        // Tlacitka Extra Life a New Game
        this._btnExtraLife = this.createButton([eAtlas_0.btnExtraLife_0, eAtlas_0.btnExtraLife_1], "btnExtraLife", new pc.Vec2(148, 158));
        this._btnExtraLife.button.on("click", this.handleBtnClickExtraLife, this);
        this._btnNewGame = this.createButton([eAtlas_0.btnNewGame_0, eAtlas_0.btnNewGame_1], "btnNewGame", new pc.Vec2(148, 158));
        this._btnNewGame.button.on("click", this.handleBtnClickNewGame, this);

        let scoreY: number;
        let btnY: number;

        if (Game.scale.maxWidth < Game.scale.maxHeight) {
            scoreY = 280;
            btnY = -200;
        }
        else {
            scoreY = 180;
            btnY = -130;
        }

        lblScore.setLocalPosition(0, scoreY, 0);
        scoreY -= 40;
        this._txtScore.setLocalPosition(0, scoreY, 0);
        scoreY -= 80;
        this._lblHighScore.setLocalPosition(0, scoreY, 0);
        this._lblNewHighScore.setLocalPosition(0, scoreY, 0);
        scoreY -= 40;
        this._txtHighScore.setLocalPosition(0, scoreY, 0);

        this._btnNewGame.setLocalPosition(0, btnY, 0);
        this._btnExtraLife.setLocalPosition(0, btnY, 0);

        this._newGameAdDelay = 2;

        // Sledovani prehrani reklamy
        Game.app.on(SDKBase.EVENT_AD_COMPLETE, this.handleAdComplete, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(): void {
        if (!this._layer.enabled) {
            // Ztmaveni pozadi
            this.updatOverlaySize(Game.scale.width, Game.scale.height);
            Game.app.on(ScaleManager.EVENT_RESIZE, this.updatOverlaySize, this);

            // Skore a high score
            let pl = Player.instance;

            this._txtScore.element.text = pl.score.value.toString();
            this._txtHighScore.element.text = SaveState.highScore.toString();

            if (pl.isNewHighScore) {
                this._lblHighScore.enabled = false;
                this._lblNewHighScore.enabled = true;

                this._txtScore.element.color = this._hsColor;
            }
            else {
                this._lblHighScore.enabled = true;
                this._lblNewHighScore.enabled = false;
                this._txtScore.element.color = this._nonHsColor;
            }

            // Tlacitka
            let btnY = this._btnExtraLife.getLocalPosition().y;

            if (pl.lifeCnt != 0 && pl.checkpoint.valid && Game.sdk.getAdState(eAdMode.videoReward) == eAdState.ready) {
                let btnSpacing = (Game.scale.maxWidth < Game.scale.maxHeight ? 120 : 140);

                this._btnExtraLife.setLocalPosition(-btnSpacing, btnY, 0);
                this._btnExtraLife.enabled = true;
                this._btnNewGame.setLocalPosition(btnSpacing, btnY, 0);
            }
            else {
                this._btnNewGame.setLocalPosition(0, btnY, 0);
                this._btnExtraLife.enabled = false;
            }

            // Zobrazit
            this._layer.enabled = true;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        if (this._layer.enabled) {
            this._layer.enabled = false;
            Game.app.off(ScaleManager.EVENT_RESIZE, this.updatOverlaySize, this);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBtnClickExtraLife(): void {
        if (Game.sdk.getAdState(eAdMode.videoReward) == eAdState.playing || Game.sdk.getAdState(eAdMode.videoSkippable) == eAdState.playing)
            return;

        Game.sdk.showAd(eAdMode.videoReward, eAdRequest.extraLife);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBtnClickNewGame(): void {
        if (Game.sdk.getAdState(eAdMode.videoReward) == eAdState.playing || Game.sdk.getAdState(eAdMode.videoSkippable) == eAdState.playing)
            return;

        if (this._newGameAdDelay == 0 && Game.sdk.getAdState(eAdMode.videoSkippable) == eAdState.ready) {
            Game.sdk.showAd(eAdMode.videoSkippable, eAdRequest.newGame);
            return;
        }

        if (this._newGameAdDelay > 0) {
            if (--this._newGameAdDelay == 0)
                Game.sdk.loadAd(eAdMode.videoSkippable);
        }

        Gameplay.instance.reset(false);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleAdComplete(res: eAdShowRes, par: eAdRequest): void {
        this._newGameAdDelay = 3;

        if (par == eAdRequest.extraLife) {
            // Nacists novou reklamu
            Game.sdk.loadAd(eAdMode.videoReward);

            if (res == eAdShowRes.success)
                Gameplay.instance.reset(true);
        }
        else if (par == eAdRequest.newGame) {
            Gameplay.instance.reset(false);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private createText(): pc.Entity {
        let txt = new pc.Entity();

        txt.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_TEXT,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            fontSize: 40,
            fontAsset: Game.app.assets.find(eFontAsset.default, pc.eAssetType.font).id,
            autoWidth: true,
            autoHeight: true,
        });
        this._layer.addChild(txt);

        return txt;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private createLabel(frameKey: string, size: pc.Vec2): pc.Entity {
        let atlas = Game.getTextureAtlas(0);
        let lbl = new pc.Entity();

        lbl.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            rect: TextureAtlasUtils.getAtlasFrameRegion(atlas, frameKey),
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            width: size.x,
            height: size.y,
        });

        this._layer.addChild(lbl);
        return lbl;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private createButton(frameKeys: string[], assetKey: string, size: pc.Vec2): pc.Entity {
        let atlas = Game.getTextureAtlas(0);
        let sprite = new pc.Sprite(Game.app.graphicsDevice, {
            atlas: atlas,
            frameKeys: frameKeys,
            pixelsPerUnit: 1,
            renderMode: pc.SPRITE_RENDERMODE_SIMPLE
        });

        let spriteAsset = new pc.Asset(assetKey, pc.eAssetType.sprite, { url: "" });
        spriteAsset.resource = sprite;
        spriteAsset.loaded = true;

        Game.app.assets.add(spriteAsset);

        let btnEntity = new pc.Entity();

        btnEntity.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            width: size.x,
            height: size.y,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            useInput: true,
            spriteAsset: spriteAsset.id,
            spriteFrame: 0
        });

        btnEntity.addComponent(pc.eCompomentType.button, {
            active: true,
            imageEntity: btnEntity,
            transitionMode: pc.BUTTON_TRANSITION_MODE_SPRITE_CHANGE,
            inactiveSpriteAsset: spriteAsset,
            hoverSpriteAsset: spriteAsset,
            hoverSpriteFrame: 0,
            pressedSpriteAsset: spriteAsset,
            pressedSpriteFrame: 1
        });

        btnEntity.button.pressedSpriteFrame

        btnEntity.button.on("mousedown", (event: pc.MouseEvent) => { event.event.stopImmediatePropagation(); });
        btnEntity.button.on("touchstart", (event: pc.MouseEvent) => { event.event.stopImmediatePropagation(); });
        this._layer.addChild(btnEntity);

        return btnEntity;
    }
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updatOverlaySize(w: number, h: number): void {
        this._overlay.element.width = w;
        this._overlay.element.height = h;
        this._overlay.setLocalPosition(-w / 2, -h / 2, 0);
    }
}